import { render } from "./ShowBasicNatalChartReport.vue?vue&type=template&id=571aa502&scoped=true"
import script from "./ShowBasicNatalChartReport.vue?vue&type=script&lang=js"
export * from "./ShowBasicNatalChartReport.vue?vue&type=script&lang=js"

import "./ShowBasicNatalChartReport.vue?vue&type=style&index=0&id=571aa502&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571aa502"]])

export default __exports__